module.exports = __webpack_public_path__ + "static/media/greek-life.5c857fc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/greek-life.svg
// module id = 647
// module chunks = 36